// About.js
import React from 'react';
import { Container, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useMobileContext } from '../../contexts/MobileContext';
import SeoTagsManager from '../../utils/SeoTagsManager';

import PartnerBrandsComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/About/partnerBrandsData.json';

import SeoDetailModuleComponent from '../../components/HomePage/SeoDetailModule/SeoDetailModuleComponent';
import SeoDetailModuleMobileComponent from '../../components/HomePage/SeoDetailModule/SeoDetailModuleMobileComponent';
import seoDetailModuleData from '../../json/components/HomePages/About/seoDetailModuleData.json';

import HippoSubLineGenericComponent from '../../components/Banners/HippoSubLineGenericComponent';
import HippoSubLineGenericMobileComponent from '../../components/Banners/HippoSubLineGenericMobileComponent';

import FooterComponent from '../../components/HomePage/Footer/FooterComponent';
import FooterMobileComponent from '../../components/HomePage/Footer/FooterMobileComponent';
import Image from '../../components/Image/Image';

const About = () => {
  const isMobile = useMobileContext();
  const isDesktop = Boolean(isMobile.isDesktop);
  const questionRoute = '/';
  const { pathname } = useLocation();

  const aboutHeaderSvg =
    'https://assets.askhippo.co.za/Pages/About/AboutHeader.svg';

  // If you already have a hippo mascot asset, drop it here.
  // (Using a placeholder path — replace with your real one)

  return (
    <>
      {SeoTagsManager.render(pathname)}
      <Box
        sx={{
          position: 'relative',
          py: isMobile ? 1 : 4,
          minHeight: isMobile ? '100vh' : 'auto',
          overflowX: 'clip',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: '#F3F6F6',
            zIndex: 0,
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <Container sx={{ mt: 4, mb: 4, position: 'relative' }}>
            {/*  About Header */}
            <Box sx={{ position: 'relative', mb: isDesktop ? 15 : 5 }}>
              <Box
                sx={{
                  position: 'relative',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  pt: isDesktop ? '49px' : 2,
                }}
              >
                {/* White Card */}
                <Box
                  sx={{
                    width: isDesktop ? '1009px' : '100%',
                    maxWidth: '100%',
                    height: isDesktop ? '212px' : '120px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '34px',
                    position: 'relative',
                    overflow: 'visible',
                    boxShadow: '0px 6px 20px rgba(0,0,0,0.06)',
                    zIndex: 1,
                  }}
                >
                  {/* ✅ Text — centered alignment but positioned 40px from top */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: isDesktop ? '40px' : '20px',
                      left: isDesktop ? '30%' : '33%',
                      transform: 'translateX(-50%)', // centers block horizontally
                      width: isDesktop ? '555px' : '60%',
                      textAlign: 'center', // ✅ centered text
                      fontFamily: 'Pally, sans-serif',
                      fontWeight: 700,
                      fontSize: isDesktop ? '4.25rem' : '1.5rem',
                      lineHeight: isDesktop ? '4.25rem' : '1.7rem',
                      letterSpacing: '-0.03em',
                      color: '#0B1F2A',
                      zIndex: 2,
                    }}
                  >
                    Learn more about hippo.co.za
                  </Box>

                  {/* ✅ Right Image — pushed further right */}
                  <Image
                    width={396}
                    height={396}
                    src={aboutHeaderSvg}
                    alt="About page header graphic"
                    sx={{
                      position: 'absolute',
                      right: isDesktop ? '-45px' : '-20px', // 🔥 pushes image outward
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: isDesktop ? '396px' : '170px',
                      height: isDesktop ? '396px' : '170px',
                      objectFit: 'contain',
                      zIndex: 5,
                      pointerEvents: 'none',
                      userSelect: 'none',
                    }}
                  />
                </Box>
              </Box>
            </Box>

            {/* Existing modules */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '24px', sm: '48px', md: '64px' },
              }}
            >
              {isMobile.isDesktop ? (
                <SeoDetailModuleComponent data={seoDetailModuleData} />
              ) : (
                <SeoDetailModuleMobileComponent data={seoDetailModuleData} />
              )}

              {isMobile.isDesktop ? (
                <HippoSubLineGenericComponent
                  route={questionRoute}
                  image={'HippoDontKnow'}
                  imageDirection={'left'}
                  title={'Compare insurance and other popular products'}
                  buttonText={'Compare now'}
                  color={'blue-white'}
                />
              ) : (
                <HippoSubLineGenericMobileComponent
                  route={questionRoute}
                  image={'HippoDontKnow'}
                  title={'Compare insurance and other popular products'}
                  buttonText={'Compare now'}
                  color={'blue'}
                />
              )}

              {/* Partner Brands */}
              {isDesktop ? (
                <PartnerBrandsComponent data={partnerBrandsData} />
              ) : (
                <PartnerBrandsMobileComponent data={partnerBrandsData} />
              )}
            </Box>
          </Container>

          {/* Footer */}
          {isDesktop ? <FooterComponent /> : <FooterMobileComponent />}
        </Box>
      </Box>
    </>
  );
};

export default About;
